export default __webpack_public_path__ + "static/media/logo.2cdb1c73.png";